import { Checkbox, FormControlLabel, Grid, IconButton, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import { DatePicker } from "@material-ui/pickers";
import { EnumListPerfilesColaboradores } from "../../../../settings/enumConfig";
import InfoIcon from "@material-ui/icons/Info";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocInputPhone from "../../../utils/MeditocInputPhone";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocPassword from "../../../utils/MeditocPassword";
import { useUsuario } from "../../../../context/UsuarioContext";

export default function FormUsuario() {
    const {
        listaPerfiles,
        usuarioSeleccionado,
        modalOpenFormUsuario,
        formUsuario,
        mostrarPassword,
        handleOpenFormUsuario,
        handleChangeMostrarPassword,
        handleChangeFormText,
        handleChangeFormDate,
        handleChangeFormCheck,
        handleSubmitFormUsuario,
    } = useUsuario();

    const {
        txtNombres,
        txtApellidoPaterno,
        txtApellidoMaterno,
        txtPerfil,
        txtFechaNacimiento,
        txtTelefono,
        txtCorreoElectronico,
        txtDomicilio,
        txtUsuario,
        txtPassword,
        txtAcceso,
    } = formUsuario;

    return (
        <MeditocModal
            size="normal"
            okmessage="Guardar"
            open={modalOpenFormUsuario}
            setopen={handleOpenFormUsuario}
            okfunc={handleSubmitFormUsuario}
            title={usuarioSeleccionado.iIdUsuario === 0 ? "Nuevo usuario" : "Editar usuario"}
            form
        >
            <Grid container spacing={3}>
                <Grid item sm={12} xs={12}>
                    <TextField
                        name="txtNombres"
                        label={txtNombres.label}
                        required={txtNombres.required}
                        value={txtNombres.value}
                        error={txtNombres.error}
                        helperText={txtNombres.error && txtNombres.message}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        autoFocus
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtApellidoPaterno"
                        label={txtApellidoPaterno.label}
                        required={txtApellidoPaterno.required}
                        value={txtApellidoPaterno.value}
                        error={txtApellidoPaterno.error}
                        helperText={txtApellidoPaterno.error && txtApellidoPaterno.message}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtApellidoMaterno"
                        label={txtApellidoMaterno.label}
                        required={txtApellidoMaterno.required}
                        value={txtApellidoMaterno.value}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtPerfil"
                        label={txtPerfil.label}
                        required={txtPerfil.required}
                        value={txtPerfil.value}
                        error={txtPerfil.error}
                        helperText={txtPerfil.error && txtPerfil.message}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        select
                    >
                        {listaPerfiles
                            .filter((perfil) => !EnumListPerfilesColaboradores.includes(perfil.iIdPerfil))
                            .map((perfil) => (
                                <MenuItem key={perfil.iIdPerfil} value={perfil.iIdPerfil}>
                                    {perfil.sNombre}
                                </MenuItem>
                            ))}
                    </TextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <DatePicker
                        name="txtFechaNacimiento"
                        label={txtFechaNacimiento.label}
                        required={txtFechaNacimiento.required}
                        value={txtFechaNacimiento.value}
                        error={txtFechaNacimiento.error}
                        helperText={txtFechaNacimiento.error && txtFechaNacimiento.message}
                        onChange={(date) => handleChangeFormDate(date, "txtFechaNacimiento")}
                        inputVariant={inputVariant}
                        variant="inline"
                        disableFuture
                        openTo="year"
                        format="dd/MM/yyyy"
                        views={["year", "month", "date"]}
                        InputProps={{ endAdornment: <MeditocDateIcon /> }}
                        fullWidth
                        /*

                        
                        clearable


                        */
                        clearlabel="Limpiar"
                        cancellabel="Cancelar"
                        autoOk={true}
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtTelefono"
                        label={txtTelefono.label}
                        required={txtTelefono.required}
                        value={txtTelefono.value}
                        error={txtTelefono.error}
                        helperText={txtTelefono.error && txtTelefono.message}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        InputProps={{
                            inputComponent: MeditocInputPhone,
                        }}
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtCorreoElectronico"
                        label={txtCorreoElectronico.label}
                        required={txtCorreoElectronico.required}
                        value={txtCorreoElectronico.value}
                        error={txtCorreoElectronico.error}
                        helperText={txtCorreoElectronico.error && txtCorreoElectronico.message}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <Tooltip
                                    title="El correo proporcionado será usado para la recuperación de las credenciales."
                                    arrow
                                    placement="top"
                                >
                                    <IconButton>
                                        <InfoIcon />
                                    </IconButton>
                                </Tooltip>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtDomicilio"
                        label={txtDomicilio.label}
                        required={txtDomicilio.required}
                        value={txtDomicilio.value}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtUsuario"
                        label={txtUsuario.label}
                        required={txtUsuario.required}
                        value={txtUsuario.value}
                        error={txtUsuario.error}
                        helperText={txtUsuario.error && txtUsuario.message}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        autoComplete="new-password"
                        fullWidth
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtPassword"
                        label={txtPassword.label}
                        required={txtPassword.required}
                        value={txtPassword.value}
                        error={txtPassword.error}
                        helperText={txtPassword.error && txtPassword.message}
                        onChange={handleChangeFormText}
                        variant={inputVariant}
                        color={inputColor}
                        type={mostrarPassword ? "text" : "password"}
                        autoComplete="new-password"
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <MeditocPassword view={mostrarPassword} setView={handleChangeMostrarPassword} />
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} className="center">
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={txtAcceso.value}
                                onChange={(e) => handleChangeFormCheck(e, "txtAcceso")}
                            />
                        }
                        label={txtAcceso.message}
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
